import { actionCreator } from 'utils';
import * as PackagingTypes from '../types/packagingTypes';

// L O A D   P A C K A G I N G
export function loadPackaging() {
    return {
        type: PackagingTypes.LOAD_PACKAGING,
    };
}

export function loadPackagingRes(data) {
    return {
        type: actionCreator(PackagingTypes.LOAD_PACKAGING, 'res'),
        data,
    };
}

export function loadPackagingErr() {
    return {
        type: actionCreator(PackagingTypes.LOAD_PACKAGING, 'err'),
    };
}
// L O A D   P A C K A G I N G


// C L O S E   O R D E R   I T E M
export function closeOrderItem(data) {
    return {
        type: PackagingTypes.CLOSE_ORDER_ITEM,
        data,
    };
}

export function closeOrderItemRes() {
    return {
        type: actionCreator(PackagingTypes.CLOSE_ORDER_ITEM, 'res'),
    };
}

export function closeOrderItemErr() {
    return {
        type: actionCreator(PackagingTypes.CLOSE_ORDER_ITEM, 'err'),
    };
}
// C L O S E   O R D E R   I T E M


// S E T   P A C K A G I N G   F I L T E R S
export function setPackagingFilters(key, value) {
    return {
        type: PackagingTypes.SET_PACKAGING_FILTERS,
        key,
        value,
    };
}

export function setPackagingFiltersRes(data) {
    return {
        type: actionCreator(PackagingTypes.SET_PACKAGING_FILTERS, 'res'),
        data,
    };
}
// S E T   P A C K A G I N G   F I L T E R S


// R E S E T   P A C K A G I N G   F I L T E R S
export function resetPackagingFilters() {
    return {
        type: PackagingTypes.RESET_PACKAGING_FILTERS,
    };
}

export function resetPackagingFiltersRes(data) {
    return {
        type: actionCreator(PackagingTypes.RESET_PACKAGING_FILTERS, 'res'),
        data,
    };
}
// R E S E T   P A C K A G I N G   F I L T E R S

// S E T   P A C K A G I N G   P A G I N A T I O N
export function setPackagingPagination(key, pagination) {
    return {
        type: PackagingTypes.SET_PACKAGING_PAGINATION,
        key,
        pagination,
    };
}
// S E T   P A C K A G I N G   P A G I N A T I O N


// S E T   P A C K A G I N G   I S   C L O S E D
export function setPackagingIsClosed(data) {
    return {
        type: PackagingTypes.SET_PACKAGING_IS_CLOSED,
        data,
    };
}
// S E T   P A C K A G I N G   I S   C L O S E D

// S E T   P A C K A G I N G   S O R T
export function setPackagingSort(key, type) {
    return {
        type: PackagingTypes.SET_PACKAGING_SORT,
        sort: {
            key,
            type,
        },
    };
}
// S E T   P A C K A G I N G   S O R T